export default __webpack_public_path__ + "static/media/contacts-white.cb44b009.svg";